import React from "react";
import { formatNumber, percentageFormat } from "../../../../../Utils/utils";

interface SecondCardModalityDetailProps {
  selectedModality: any;
  data: any;
}

const SecondCardModalityDetail = ({
  selectedModality,
  data,
}: SecondCardModalityDetailProps) => {
  const findProductByMatch = () => {
    if (!data.producto || !Array.isArray(data.producto)) {
      return null;
    }

    const matchedProduct = data.producto.find((producto: any) => {
      if (producto.modalidad !== selectedModality.modalidad) {
        return false;
      }

      const periodoGarantizado = parseInt(selectedModality.periodoGarantizado || "0");
      const anosRT = parseInt(selectedModality.anosRT || "0");

      if (producto.periodoGarantizado !== periodoGarantizado) {
        return false;
      }
      if (producto.anosRT !== anosRT) {
        return false;
      }

      return true;
    });

    return matchedProduct;
  };

  const productMatch = !selectedModality.respuestaMacro ? findProductByMatch() : null;
  const respuestaMacro = selectedModality.respuestaMacro || (productMatch && productMatch.respuestaMacro);

  return (
    <div className="card-verify ">
      <div className="card-verify__rows">
        {respuestaMacro && (
          <div>
            <div className="card-verify__quote">Cesión Comisión</div>
            <div className="card-verify__data">
              {data.estado === "recalculado" || data.estado === "emitida"
                ? data.modalidadRecalculada &&
                  data.modalidadRecalculada.recalculo &&
                  data.modalidadRecalculada.recalculo.cesionComision
                  ? data.modalidadRecalculada.recalculo.cesionComision
                  : "--"
                : respuestaMacro.cesionComision || "--"}
            </div>
          </div>
        )}
        {respuestaMacro && (
          <div>
            <div className="card-verify__quote">TIR(%)</div>
            <div className="card-verify__data">
              {data.estado === "recalculado" || data.estado === "emitida"
                ? data.modalidadRecalculada &&
                  data.modalidadRecalculada.recalculo
                  ? percentageFormat(data.modalidadRecalculada.recalculo.tir)
                  : "--"
                : percentageFormat(respuestaMacro.tir) || "--"}
            </div>
          </div>
        )}
        <div>
          <div className="card-verify__quote">VAN</div>
          <div className="card-verify__data">
            {data.estado === "recalculado" || data.estado === "emitida"
              ? data.modalidadRecalculada && data.modalidadRecalculada.recalculo
                ? formatNumber.new(data.modalidadRecalculada.recalculo.van)
                : "--"
              : respuestaMacro
                ? formatNumber.new(respuestaMacro.van)
                : "--"}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      {respuestaMacro && (
        <div className="card-verify__rows">
          <div>
            <div className="card-verify__quote">Renta Vitalicia</div>
            <div className="card-verify__data">
              {data.estado === "recalculado" || data.estado === "emitida"
                ? data.modalidadRecalculada &&
                  data.modalidadRecalculada.recalculo &&
                  data.modalidadRecalculada.recalculo.primaPensionRv
                  ? formatNumber.new(
                      data.modalidadRecalculada.recalculo.primaPensionRv
                    )
                  : "--"
                : respuestaMacro.primaPensionRv
                  ? formatNumber.new(respuestaMacro.primaPensionRv)
                  : "--"}
            </div>
          </div>
          <div>
            <div className="card-verify__quote">Renta Temporal</div>
            <div className="card-verify__data">
              {data.estado === "recalculado" || data.estado === "emitida"
                ? data.modalidadRecalculada &&
                  data.modalidadRecalculada.recalculo &&
                  data.modalidadRecalculada.recalculo.primaPensionRt
                  ? formatNumber.new(
                      data.modalidadRecalculada.recalculo.primaPensionRt
                    )
                  : "--"
                : respuestaMacro.primaPensionRt
                  ? formatNumber.new(respuestaMacro.primaPensionRt)
                  : "--"}
            </div>
          </div>
          <div>
            <div className="card-verify__quote">Gasto de Sepelio</div>
            <div className="card-verify__data">
              {data.estado === "recalculado" || data.estado === "emitida"
                ? data.modalidadRecalculada &&
                  data.modalidadRecalculada.recalculo &&
                  data.modalidadRecalculada.recalculo.gastoSepelio
                  ? formatNumber.new(
                      data.modalidadRecalculada.recalculo.gastoSepelio
                    )
                  : "--"
                : respuestaMacro.gastoSepelio
                  ? formatNumber.new(respuestaMacro.gastoSepelio)
                  : "--"}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SecondCardModalityDetail;
